var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preview-rewards-card" }, [
    _c(
      "div",
      { staticClass: "preview-rewards-card-list" },
      _vm._l(_vm.items, function (item, index) {
        return _c("v-flex", { key: index }, [
          item.quantity > 0
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "first-item" }, [
                  _c("img", {
                    staticClass: "mr-2",
                    attrs: { src: item.img, width: "30" },
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mr-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.quantity) +
                        "x " +
                        _vm._s(item.title) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "trigger" }, [
                  _vm._v("\n          " + _vm._s(item.trigger) + "\n        "),
                ]),
              ])
            : _vm._e(),
        ])
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }